













import { Component, Vue } from 'vue-property-decorator';
import Popup from '@/components/popups/Popup.vue';
import { namespace } from 'vuex-class';
import { playSound } from '@/utils/playSound';

const ui = namespace('UI');

const puzzle = namespace('Puzzle');

@Component({
  components: {
    Popup,
  },
})
export default class ClearPuzzlePopup extends Vue {
  @ui.Mutation
  private closePopup!: () => void;

  @puzzle.Mutation
  private clearPuzzle!: () => void;

  private change() {
    playSound('buttonClickSound');
    this.clearPuzzle();
    this.closePopup();
  }

  private cancel() {
    playSound('buttonClickSound');
    this.closePopup();
  }

  private clear: string = (window as any).languages['ClearPuzzle'];
  private yes: string = (window as any).languages['Yes'];
  private no: string = (window as any).languages['No'];
}
